// eslint-disable-next-line import/prefer-default-export
export const LOCAL_STORAGE_KEY_UPDATE_OLD_CREDENTIALS = 'riseup.update_old_creds_page';
